import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import './App.css';

class SolaraSalesChartWidget extends HTMLElement {
    connectedCallback() {
        if (!this.root) {
            this.root = createRoot(this);
        }
        this.root.render(<App />);
    }
    disconnectedCallback() {
        if (this.root) {
            this.root.unmount();
            this.root = null;
        }
    }
}

const ELEMENT_ID = 'solara-sales-chart-widget';
if (!customElements.get(ELEMENT_ID)) {
    customElements.define(ELEMENT_ID, SolaraSalesChartWidget);
}
